var _g, _g2, _polygon, _polygon2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3,3)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "118,18 62,108 98,108 82,182 148,82 108,82",
    fill: "#00FFFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3,-3)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "118,18 62,108 98,108 82,182 148,82 108,82",
    fill: "#FF00FF"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "118,18 62,108 98,108 82,182 148,82 108,82",
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "118,18 62,108 98,108 82,182 148,82 108,82",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 2,
    strokeLinejoin: "round",
    transform: "translate(3,3)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 105,
    y1: 52,
    x2: 84,
    y2: 108,
    stroke: "#CC00CC",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 108,
    y1: 55,
    x2: 87,
    y2: 111,
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 22,
    x2: 142,
    y2: 12,
    stroke: "#CC00CC",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 133,
    y1: 25,
    x2: 145,
    y2: 15,
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 142,
    y1: 38,
    x2: 158,
    y2: 32,
    stroke: "#CC00CC",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 41,
    x2: 161,
    y2: 35,
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 76,
    y1: 182,
    x2: 66,
    y2: 194,
    stroke: "#CC00CC",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 79,
    y1: 185,
    x2: 69,
    y2: 197,
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 186,
    x2: 84,
    y2: 198,
    stroke: "#CC00CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.a11cdcce7969e5348a90fcb38c73157c.svg";
export { ForwardRef as ReactComponent };